import {
  HASH_REDEEM_STARTED,
  HASH_REDEEM_SUCCESS,
  HASH_REDEEM_FAILED,
  HASH_AUTH_CLEAR,
  LOGOUT_SUCCESS,
} from '../actions/types';
import initialState from '../initialState';

export default function hashAuthReducer(state = initialState.hashAuth, action) {
  switch (action.type) {
    case HASH_REDEEM_STARTED:
      return { ...initialState.hashAuth, status: 'loading' };
    case HASH_REDEEM_SUCCESS:
      return {
        hash: action.payload.hash,
        hashToken: action.payload.hashToken,
        scope: action.payload.scope,
        expiresAt: action.payload.expiresAt,
        hasNormalAccess: !!action.payload.hasNormalAccess,
        status: 'ready',
        error: null,
      };
    case HASH_REDEEM_FAILED:
      return { ...initialState.hashAuth, status: 'error', error: action.payload };
    case HASH_AUTH_CLEAR:
    case LOGOUT_SUCCESS:
      return { ...initialState.hashAuth };
    default:
      return state;
  }
}
